import { Injectable } from '@angular/core';
import { sizeDesktop } from './device-info.config';

@Injectable({
  providedIn: 'root',
})
export class DeviceInfoService {
  constructor() {}

  isDesktop(): boolean {
    let screenSize = window.innerWidth;
    if (screenSize >= sizeDesktop) {
      return true;
    }
    return false;
  }
}
